//行业swiper
var mySwiperIndustry = new Swiper ('.swiper-container-industry', {
  // initialSlide :1,
  direction: 'horizontal', // 垂直切换选项
  loop: false, // 循环模式选项
  // loop: ($("#bannerNumber").val() > 1), // 循环模式选项
  observer:true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents:true,//修改swiper的父元素时，自动初始化swiper

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },

  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination',
  },
});

var swiperOpotionBannerIndexloop = true;
if ($("#bannerNumber") && $("#bannerNumber").val() <= 1) {
  swiperOpotionBannerIndexloop = false;
}
var mySwiper = new Swiper ('.swiper-container-index', {
  // initialSlide :1,
  direction: 'horizontal', // 垂直切换选项
  slidesPerView: 'auto',
  centeredSlides: true,
  loop: swiperOpotionBannerIndexloop, // 循环模式选项
  observer:true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents:true,//修改swiper的父元素时，自动初始化swiper

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },

  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.next-swiper-btn',
    prevEl: '.prev-swiper-btn',
  },
  on: {
    slideChangeTransitionStart:function () {
      var videoContentELs = document.querySelectorAll('.swiper-content-video');
      videoContentELs.forEach(function (videoItem) {
        videoItem.querySelector('video').classList.add('hide');
        videoItem.querySelector('video').pause();
        videoItem.querySelector('img').classList.remove('hide');
        videoItem.querySelector('.shop-playicon').classList.remove('hide');
        if (mySwiper) {
          mySwiper.autoplay.start();
        }
      });
    }
  }
});

//视频
var videoContentEls = document.querySelectorAll('.swiper-content-video');
if(videoContentEls.length > 0){
  videoContentEls.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.currentTarget.querySelector('video').classList.remove('hide');
      e.currentTarget.querySelector('video').play();
      e.currentTarget.querySelector('img').classList.add('hide');
      e.currentTarget.querySelector('.shop-playicon').classList.add('hide');
      mySwiper.autoplay.stop();
    });
  });
}

//首页推荐专题swiper
var topicSwiper = new Swiper ('.topic-swiper-container', {
  // initialSlide :1,
  slidesPerView: 'auto',
  direction: 'horizontal', // 垂直切换选项
  loop: false, // 循环模式选项
  observer:true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents:true,//修改swiper的父元素时，自动初始化swiper
  freeMode: true
});


//大咖说swiper
var topicSwiper2 = new Swiper ('.dks-swiper-container', {
  // initialSlide :1,
  slidesPerView: 'auto',
  direction: 'horizontal', // 垂直切换选项
  loop: false, // 循环模式选项
  observer:true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents:true,//修改swiper的父元素时，自动初始化swiper
  freeMode: true
});


// 关闭弹层
// if($.cookie('modelView') == null){
//   $(".model-view").show();
// }else{
//   $(".model-view").hide();
// }
// $(".close").on("click",function(){
//   $(".model-view").hide();
//   var end = new Date( 
//     new Date(
//         new Date().toLocaleDateString()
//     ).getTime() + 24 * 60 * 60 * 1000
//   );
//   end.setTime(end.getTime())
//   $.cookie('modelView', 'true', { expires: end });
// })
//文章详情感兴趣产品swiper

var articleInterestedSwiper = new Swiper('.swiper-container-Interested', {

  slidesPerView: 'auto',
  direction: 'horizontal', // 垂直切换选项
  loop: false, // 循环模式选项
  observer:true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents:true,//修改swiper的父元素时，自动初始化swiper
  freeMode: true

});

/*var mainTabs = new Swiper('.swiper-container-maintab',{
  freeMode: true,
  slidesPerView: 'auto',
  direction: 'horizontal', // 垂直切换选项
  loop: false, // 循环模式选项
  on:{
    tap: function(event){

    }
  }
})*/
